import React from 'react';
import { motion } from 'framer-motion';
import { Heart, ArrowRight, Gift, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const GIVEBUTTER_URL = "https://givebutter.com/XT2qPn";

const DonationThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white pt-24" data-testid="donation-thank-you">
      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-8">
              <CheckCircle className="w-12 h-12 text-green-500" />
            </div>

            <h1 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight leading-tight mb-6">
              Thank You for Your
              <span className="block text-[#1E3A8A]">Generous Donation</span>
            </h1>

            <p className="text-xl text-slate-600 font-light leading-relaxed mb-8 max-w-2xl mx-auto">
              Your contribution to The Prestigious Travel Club Foundation helps us feed families,
              support veterans, fund children's healthcare, and build stronger communities.
              Every dollar makes a real difference.
            </p>
          </motion.div>

          {/* Impact Highlights */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            {[
              { icon: Heart, title: 'Families Fed', desc: 'Your donation helps provide meals to families in need.' },
              { icon: Gift, title: 'Children Supported', desc: "Funds go toward children's hospitals and programs." },
              { icon: CheckCircle, title: 'Veterans Helped', desc: 'Supporting those who served our country.' },
            ].map((item, idx) => (
              <div key={item.title} className="p-6 rounded-2xl border border-slate-200 text-center">
                <item.icon className="w-8 h-8 text-[#1E3A8A] mx-auto mb-3" />
                <h3 className="font-semibold text-slate-800 mb-2">{item.title}</h3>
                <p className="text-sm text-slate-500 font-light">{item.desc}</p>
              </div>
            ))}
          </motion.div>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            <Button
              onClick={() => navigate('/')}
              className="bg-[#1E3A8A] hover:bg-[#1E3A8A]/90 text-white px-8 py-6 text-lg rounded-full"
              data-testid="back-to-home-btn"
            >
              Back to Home
            </Button>
          </motion.div>

          <motion.p
            className="mt-12 text-sm text-slate-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            All donations to The Prestigious Travel Club Foundation are tax-deductible.
            A receipt will be sent to your email.
          </motion.p>
        </div>
      </section>
    </div>
  );
};

export default DonationThankYou;
